module.exports = "/images/Egypt.png?ced0382e08f65a89a0831780762c2dc2";